module.exports = __webpack_public_path__ + "img/IMG_9907.10a66022.jpg";